import React from 'react';
import { useDispatch } from 'react-redux';
import { Card, CardContent, Grid } from '@mui/material';

import { TabFab, usePagination, useSelection, useSettings, Utils } from 'app/main/components';
import { ViewList } from 'app/main/components/page-layouts';

import MarketingActionsDetailsSectionAddRows from '../sections/MarketingActionsDetailsSectionAddRows';
import MarketingActionsDetailsSectionDeleteRows from '../sections/MarketingActionsDetailsSectionDeleteRows';

import MarketingActionsRowsListItem from '../../marketingactions-rows/MarketingActionsRowsListItem';

interface MarketingActionsRowsTabProps {
	table: string;
	model: any;
}

export default function MarketingActionsRowsTab(props: MarketingActionsRowsTabProps) {
	const dispatch = useDispatch();
	const { t } = useSettings();

	// Can be edited only if draft or interrupted
	const canEdit = props.model.maac_mast_id !== 4;

	const [refresh, setRefresh] = React.useState(false);
	const updateRefresh = () => setRefresh(state => !state);

	const paginationProps = usePagination({
		module: 'marketingactions_rows',
		filter: {
			defaultFilters: [
				{ filt_field: 'marw_table', filt_clause: 'equals', filt_value: props.table },
				{ filt_field: 'marw_maac_uid', filt_clause: 'equals', filt_value: props.model.maac_uid }
			]
		},
		paginator: { defaultNRows: 100 }
	});

	const { selectedItems, setSelectedItems } = useSelection({ module: 'marketingactions_rows', isSelecting: canEdit });

	const onFabClick = () => {
		Utils.executeStored({
			action: 'st_marketingactions_rows_delete',
			dispatch,
			data: {
				marw_maac_uid: props.model.maac_uid,
				values: selectedItems.map(item => item.marw_uid)
			},
			successHandler: () => {
				dispatch(Utils.alertSuccessMsg(t));
				setSelectedItems([]);
				updateRefresh();
			}
		});
	};

	return (
		<Grid container spacing={2}>
			{canEdit && (
				<>
					<Grid size={{ md: 8, sm: 6, xs: 12 }}>
						<MarketingActionsDetailsSectionAddRows
							maacUid={props.model.maac_uid}
							table={props.table}
							isLoading={paginationProps.paginatorProps.isLoading}
							updateRefresh={updateRefresh}
						/>
					</Grid>
					<Grid size={{ md: 4, sm: 6, xs: 12 }}>
						<MarketingActionsDetailsSectionDeleteRows
							maacUid={props.model.maac_uid}
							table={props.table}
							isLoading={paginationProps.paginatorProps.isLoading}
							updateRefresh={updateRefresh}
						/>
					</Grid>
				</>
			)}
			<Grid size={12}>
				<Card variant="outlined" className="rounded-8">
					<CardContent className="p-0 last:p-0">
						<ViewList
							module="marketingactions_rows"
							itemLayout={MarketingActionsRowsListItem}
							paginationProps={paginationProps}
							refresh={refresh}
							updateRefresh={updateRefresh}
							selectionProps={canEdit ? { mode: 'multiple', selectedItems } : undefined}
						/>
					</CardContent>
				</Card>
			</Grid>
			{selectedItems.length > 0 && (
				<TabFab label={t('VIEW_ITEM_BUTTON_DELETE')} icon="delete" onClick={onFabClick} />
			)}
		</Grid>
	);
}
